import { cn } from "./cn";

export const VIEW_MODES = ["grid", "list"] as const;

export type ViewMode = (typeof VIEW_MODES)[number];

const VIEW_ICONS = {
  grid: "ri-grid-fill",
  list: "ri-list-check",
} as const satisfies Record<ViewMode, string>;

export interface ViewToggleProps {
  value: ViewMode;
  onChange: (view: ViewMode) => void;
  labels?: Record<ViewMode, string>;
  className?: string;
}

export function ViewToggle({ value, onChange, labels, className }: ViewToggleProps) {
  return (
    <div
      className={cn(
        "ml-auto flex w-fit shrink-0 rounded-lg border border-line bg-card p-1",
        className,
      )}
      role="group"
    >
      {VIEW_MODES.map((mode) => (
        <button
          key={mode}
          type="button"
          onClick={() => onChange(mode)}
          aria-pressed={value === mode}
          aria-label={labels?.[mode] ?? mode}
          title={labels?.[mode]}
          className={cn(
            "h-7 w-8 inline-flex items-center justify-center rounded-md transition-colors",
            value === mode
              ? "bg-primary-500 text-on-primary"
              : "text-content-secondary hover:bg-subtle hover:text-content",
          )}
        >
          <i className={VIEW_ICONS[mode]} />
        </button>
      ))}
    </div>
  );
}
